import {action} from 'typesafe-actions';

export enum UserFeedbackActionTypes {
  SET_ERROR_FEEDBACK = 'SET_ERROR_FEEDBACK',
  SET_INFO_FEEDBACK = 'SET_INFO_FEEDBACK',
  SET_WARNING_FEEDBACK = 'SET_WARNING_FEEDBACK',
  CLOSE_FEEDBACK = 'CLOSE_FEEDBACK',
}

type UserFeedbackCommonProps = {
  title: string;
  message: string;
  showHeader: boolean;
};

export const UserFeedbackActions = {
  setErrorUserFeedback: (payload: UserFeedbackCommonProps) =>
    action(UserFeedbackActionTypes.SET_ERROR_FEEDBACK, payload),
  setInfoUserFeedback: (payload: UserFeedbackCommonProps) =>
    action(UserFeedbackActionTypes.SET_INFO_FEEDBACK, payload),
  setWarningUserFeedback: (payload: UserFeedbackCommonProps) =>
    action(UserFeedbackActionTypes.SET_WARNING_FEEDBACK, payload),
  closeFeedback: () => action(UserFeedbackActionTypes.CLOSE_FEEDBACK, null),
};
